export default {
  today: 'Today',
  yesterday: 'Yesterday',

  empty: 'No call records',
} as const;
